var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { loadingSlice } from './LoadingStore';
export var defaultLongPlayState = {
    game: {},
    boards: {},
    collections: [],
    boardDetails: {},
    winsAndPrizes: {},
};
// REDUCERS
// basic actions that affect this object only
var getBoardsReducer = function (state, action) {
    var _a;
    var _b, _c, _d;
    return __assign(__assign({}, state), { boards: __assign(__assign({}, state.boards), (_a = {}, _a[(_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.game_id] = Array.isArray((_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.boards) ? (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.boards : [], _a)) });
};
var getGameReducer = function (state, action) {
    var _a, _b;
    return __assign(__assign({}, state), { game: __assign(__assign({}, state.game), ((_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.game) !== null && _b !== void 0 ? _b : {})), collections: action.payload.collections, boards: action.payload.boards });
};
var getBoardReducer = function (state, action) {
    var _a;
    var _b, _c, _d;
    return __assign(__assign({}, state), { boardDetails: __assign(__assign({}, state.boardDetails), (_a = {}, _a[(_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.board_id] = (_d = (_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.result) !== null && _d !== void 0 ? _d : {}, _a)) });
};
var getWinsAndPrizesReducer = function (state, action) {
    var _a;
    var _b, _c, _d;
    return __assign(__assign({}, state), { winsAndPrizes: __assign(__assign({}, state.winsAndPrizes), (_a = {}, _a[(_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.game_id] = Array.isArray((_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.result) ? (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.result : [], _a)) });
};
var resetReducer = function () {
    return __assign({}, defaultLongPlayState);
};
export var longPlaySlice = createSlice({
    name: 'longPlayGame',
    initialState: defaultLongPlayState,
    reducers: {
        getBoards: getBoardsReducer,
        getGame: getGameReducer,
        getBoard: getBoardReducer,
        getWinsAndPrizes: getWinsAndPrizesReducer,
        reset: resetReducer,
    },
});
// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
var getGame = function (dispatch, title, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getGame' }));
                return [4 /*yield*/, apiClient().getGameEngineGame({ title: title })];
            case 1:
                result = _a.sent();
                dispatch(longPlaySlice.actions.getGame(__assign({ title: title }, result)));
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getGame' }));
                return [2 /*return*/];
        }
    });
}); };
var getBoards = function (dispatch, game_id, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getBoards' }));
                return [4 /*yield*/, apiClient().getGameEngineGameBoards({ game_id: game_id })];
            case 1:
                result = _a.sent();
                dispatch(longPlaySlice.actions.getBoards(__assign({ game_id: game_id }, result)));
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getBoards' }));
                return [2 /*return*/];
        }
    });
}); };
var getBoard = function (dispatch, payload, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getBoard' }));
                return [4 /*yield*/, apiClient().getGameEngineGameBoard({ game_id: payload === null || payload === void 0 ? void 0 : payload.game_id, board_id: payload === null || payload === void 0 ? void 0 : payload.board_id })];
            case 1:
                result = _a.sent();
                dispatch(longPlaySlice.actions.getBoard(__assign(__assign({}, payload), { result: result })));
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getBoard' }));
                return [2 /*return*/];
        }
    });
}); };
var getWinsAndPrizes = function (dispatch, game_id, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getWinsAndPrizes' }));
                return [4 /*yield*/, apiClient().getGameEngineGameWinTypesWithPrizes({ game_id: game_id })];
            case 1:
                result = _a.sent();
                dispatch(longPlaySlice.actions.getWinsAndPrizes({ game_id: game_id, result: result }));
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getWinsAndPrizes' }));
                return [2 /*return*/];
        }
    });
}); };
//actions that get exported to the views
export var longPlayActions = function (dispatch, apiClient) {
    return {
        getGame: function (title) { return getGame(dispatch, title, apiClient); },
        getBoards: function (game_id) { return getBoards(dispatch, game_id, apiClient); },
        getBoard: function (payload) { return getBoard(dispatch, payload, apiClient); },
        getWinsAndPrizes: function (game_id) { return getWinsAndPrizes(dispatch, game_id, apiClient); },
        reset: function () { return dispatch(longPlaySlice.actions.reset()); },
    };
};
